/* ============================================================
   LENIDESIGN — ANIMATIONS
   Scroll reveal via IntersectionObserver — Vanilla JS
   Zero dependencies | ~2KB gzipped
   ============================================================ */

(function () {
  'use strict';

  /* ── REDUCED MOTION CHECK ── */
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  /* ── SCROLL REVEAL ── */
  function initScrollReveal() {
    const elements = document.querySelectorAll('.leni-reveal');
    if (!elements.length) return;

    if (prefersReducedMotion) {
      elements.forEach(function (el) {
        el.classList.add('leni-reveal--visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('leni-reveal--visible');
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -56px 0px',
      }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── STICKY HEADER SCROLL BEHAVIOR ── */
  function initStickyHeader() {
    const header = document.querySelector('.leni-header');
    if (!header) return;

    let lastScrollY = window.scrollY;
    let ticking = false;

    function updateHeader() {
      const scrollY = window.scrollY;

      if (scrollY > 80) {
        header.classList.add('leni-header--scrolled');
      } else {
        header.classList.remove('leni-header--scrolled');
      }

      lastScrollY = scrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── MOBILE MENU DRAWER ── */
  function initMobileMenu() {
    const toggle = document.querySelector('.leni-header__burger');
    const drawer = document.querySelector('.leni-header__drawer');
    const overlay = document.querySelector('.leni-header__overlay');
    const closeBtn = document.querySelector('.leni-header__drawer-close');

    if (!toggle || !drawer) return;

    function openDrawer() {
      drawer.classList.add('leni-header__drawer--open');
      if (overlay) overlay.classList.add('leni-header__overlay--visible');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      drawer.classList.remove('leni-header__drawer--open');
      if (overlay) overlay.classList.remove('leni-header__overlay--visible');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      const isOpen = drawer.classList.contains('leni-header__drawer--open');
      isOpen ? closeDrawer() : openDrawer();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* ── VIDEO AUTOPLAY ON SCROLL ── */
  function initVideoReveal() {
    const videos = document.querySelectorAll('.leni-video-autoplay');
    if (!videos.length) return;

    const videoObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.play().catch(function () {});
          } else {
            entry.target.pause();
          }
        });
      },
      { threshold: 0.3 }
    );

    videos.forEach(function (video) {
      videoObserver.observe(video);
    });
  }

  /* ── HERO ENTRANCE ANIMATION ── */
  function initHeroAnimation() {
    const hero = document.querySelector('.leni-hero');
    if (!hero || prefersReducedMotion) return;

    const image = hero.querySelector('.leni-hero__image');
    const card = hero.querySelector('.leni-hero__card');

    if (image) {
      image.style.opacity = '0';
      image.style.transform = 'scale(1.04)';
      image.style.transition = 'opacity 900ms cubic-bezier(.16,1,.3,1), transform 900ms cubic-bezier(.16,1,.3,1)';
      requestAnimationFrame(function () {
        setTimeout(function () {
          image.style.opacity = '1';
          image.style.transform = 'scale(1)';
        }, 60);
      });
    }

    if (card) {
      card.style.opacity = '0';
      card.style.transform = 'translateY(24px)';
      card.style.transition = 'opacity 700ms cubic-bezier(.16,1,.3,1), transform 700ms cubic-bezier(.16,1,.3,1)';
      requestAnimationFrame(function () {
        setTimeout(function () {
          card.style.opacity = '1';
          card.style.transform = 'translateY(0)';
        }, 220);
      });
    }
  }

  /* ── INIT ON DOM READY ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initScrollReveal();
    initStickyHeader();
    initMobileMenu();
    initVideoReveal();
    initHeroAnimation();
  }

})();
